import { Make, MakeModel, ControlItem } from '../types';
import { TOP_LIST_COUNT } from '../constants';

export const getModelList = (
  makes: Make[] = [],
  makeId?: string,
  topCount: number = TOP_LIST_COUNT
) => {
  const selectedMark = makes.find(m => String(m.id) === makeId);
  const all = selectedMark?.model_items ?? [];
  const top = selectedMark?.model_items_popular ?? [];
  const hasMore = all.length > topCount;

  return {
    all,
    top,
    hasMore
  };
};

export const isPureNumber = (value: string) => /^\d+$/.test(value);
export const onlyDigits = (s: string) => s.replace(/\D/g, '');

export const formatThousands = (digits: string) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const normalizeNumberData = (
  array: number[] = [],
  options: { formatThousands?: boolean } = {}
) => {
  const { formatThousands: shouldFormat = false } = options;

  return array.map(item => ({
    id: item,
    name: shouldFormat ? formatThousands(String(item)) : String(item)
  }));
};

export type OptionRow = MakeModel | ControlItem;

export const computeBaseList = (
  filteredOptions: MakeModel[],
  top: MakeModel[],
  displayValue: string,
  showAll: boolean
): MakeModel[] => {
  if (displayValue) return filteredOptions;
  if (showAll) return filteredOptions;

  return top;
};

export const computeFinalList = (
  baseList: MakeModel[],
  displayValue: string,
  showAll: boolean,
  hasMore: boolean,
  labels: { showAll: string; collapse: string }
): OptionRow[] => {
  if (displayValue) return baseList;
  if (!showAll && hasMore) {
    return [...baseList, { isShowAll: true, id: 'show_more', name: labels.showAll }];
  }
  if (showAll) {
    return [...baseList, { isShowAll: false, id: 'collapse', name: labels.collapse }];
  }
  return baseList;
};

export const isControlItem = (x: OptionRow): x is ControlItem => 'isShowAll' in x;
